<script>
    import {onMount} from "svelte";
    import wrappedFetch from "../wrappedFetch.js";
    import DataTable from "../components/data-table.svelte";
    import Card from "./components/card.svelte";
    import Spinner from "./components/spinner.svelte";
    import Router, { route } from "../router.js"; 

    import {AuthUser} from '../store.js';


    let isPageLoading;

    onMount(async()=>{
        isPageLoading=true;
        OnPageLoad();
        jQuery('[data-toggle="tooltip"]').tooltip();
        isPageLoading=false;
    })
    let Subscriptions = [];
    let SubscriptionsNew = [];

    let AllSubscriptions = [];

    async function OnPageLoad() {
    //const OnPageLoad=async()=>{
        isPageLoading=true;
        let customers = await getSubscriptions();
        Subscriptions = customers.current;
        SubscriptionsNew = customers.pending;
        AllSubscriptions = Subscriptions;
        jQuery('.nav-tabs a[href="#sub1"]').tab('show');
        isPageLoading=false;
    }
    
    async function getSubscriptions(status) {
        let resp = await wrappedFetch('/api/subscriptions/GetCustomerSubscription', {method: "get"}); 
        return await resp.json();
    }
    
    let columnDefs = [{ type: 'date-euro', targets: [3] }];
    let order = [[3, "asc"]];

    const back=async()=>{
        OnPageLoad();
     }

     const handlesNewSubscription=async()=>{
        Router.route("/app/subscriptions/new");
     }

    // const showFullDetails=async(user, pending)=>{
    //     resetModal();
    //     ShowDeactive = false;
    //     isPageLoading=true;
    //     ShowPending = false;
    //     ShowSubscription = false;

    //     if (pending){
    //         ShowPending = true;
    //         ShowDelete = true;
    //     }
    //     else
    //         ShowSubscription = true;

    //     isPageLoading=false;
    // }
    
    let subscriptionTypes = [
        { id: "-", text: `All Subscriptions` },
		{ id: true, text: `Active` },
		{ id: false, text: `Expired` }
    ];
    
    let subscriptionTypeSelected = "";
    const FilterSubscriptionData=async(status)=>{ 
        if (status=="-"){
            Subscriptions = AllSubscriptions;
        }
        else{
            Subscriptions = AllSubscriptions.filter(m => m.active === status);
        }
    }
    
    function getLinks(url) {
        if (jQuery('div.dtr-bs-modal').length > 0){
            jQuery('.dtr-bs-modal').modal('hide');
        }
        Router.route(url);
        return false;
    }

    document.addEventListener('click', function (event) {
        if (!event.target.parentElement.matches('.subscriptionLink')) return;
            getLinks('/app/subscriptions/' + parseInt(event.target.parentElement.getAttribute('data')));
    }, false);
    document.addEventListener('click', function (event) {
        if (!event.target.parentElement.matches('.subscriptionActiveLink')) return;
            getLinks('/app/subscriptions/' + parseInt(event.target.parentElement.getAttribute('data')));
    }, false);

    function showMatchOptionsMobile(event){
        if (event.detail.text == "TableUpdated"){
            jQuery(".table").on('click','.subscriptionLink', function () { 
                getLinks('/app/subscriptions/' + parseInt(jQuery(this).attr('data')));
            });
        }
    }; 
</script>



<h1>Subscriptions</h1>
{#if isPageLoading}
  <Spinner/>
{:else}
    <div class=" mb-5">
        <div class="row mb-2">
            <div class="col-6"><h3>Leads</h3></div>
            <div class="col-6 text-right">

                <!-- Temp hardcode button change to stop everyone adding subs to Nimbus-->
                {#if ($AuthUser.universalId == "ssatiarujikano.000") || ($AuthUser.universalId == "hdaniels7.000") || ($AuthUser.universalId == "jfirmager.000") || ($AuthUser.universalId == "haspinall.000") || ($AuthUser.universalId == "jjanssen1.000") }
                <button class="btn btn-primary" type="button" on:click|preventDefault={handlesNewSubscription}>Add new subscription</button>
                {/if}
            </div>
        </div>
            <div class="row">
            <div class="col-12">
                <Card cardTable={true}>
                    <div slot="body">
                        <DataTable {columnDefs} {order} ResponsiveHeader='2' DataLength={SubscriptionsNew.length} message="There is currently no pending subscriptions" on:message={showMatchOptionsMobile}>
                            <thead>
                                <tr>
                                    <th>Service</th>
                                    <th>School / MAT</th>
                                    <th>Contact Details</th>
                                    <th>Sign Up Date</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {#each SubscriptionsNew as subscription}
                                    <tr>
                                        <td>{subscription.serviceName}</td>
                                        <td>
                                            {#if (subscription.schoolID == 0)}
                                                {subscription.matName}
                                            {:else}
                                                {subscription.estab} ({subscription.leaid}-{subscription.dfESID})
                                            {/if}
                                        </td>
                                        <td>{subscription.contactName} {#if (subscription.contactLastName != null)}{subscription.contactLastName}{/if}<br>
                                            {#if (subscription.contactEmail != null)}
                                                <small>{subscription.contactEmail} ({subscription.contactNumber})</small>
                                            {/if}
                                        </td>
                                        <td>{subscription.currrentSubscriptionStartstr}</td>
                                        <td>
                                            <a class="subscriptionLink" 
                                            on:click="{() => getLinks('/app/subscriptions/' + subscription.customersID)}" 
                                            role="button" data={subscription.customersID} 
                                            href="#" data-toggle="tooltip" 
                                            target="_self" 
                                            title="Edit Pending Subscription"><span class="material-icons">edit</span></a>
                                            <!-- <span class="material-icons" style="cursor:pointer" on:click={() => showFullDetails(subscription, true)}>edit</span> -->
                                        </td>
                                    </tr>
                                {/each}
                            </tbody>
                        </DataTable>
                    </div>
                </Card>
            </div>
        </div>
    </div>

    <div>
        <div class="row mb-2">
            <div class="col-6 col-lg-9"><h3>Customers</h3></div>
            <div class="col-6 col-lg-3 text-right">
                <select bind:value={subscriptionTypeSelected} on:change="{() => FilterSubscriptionData(subscriptionTypeSelected)}" class="form-control">
                    {#each subscriptionTypes as type}
                        <option value={type.id}>
                            {type.text}
                        </option>
                    {/each}
                </select>  
            </div>
        </div>
        <div>
            <Card cardTable={true}>
                <div slot="body">
                    <DataTable {columnDefs} {order} ResponsiveHeader='2' DataLength={Subscriptions.length} message="There is currently no subscriptions">
                        <thead>
                            <tr>
                                <th>Service</th>
                                <th>School / MAT</th>
                                <!-- <th>Contact Details</th> -->
                                <th>Office</th>
                                <th>Renewal Date</th>
                                <th>Annual Fee</th>
                                <th>Active</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {#each Subscriptions as subscription}
                                <tr>
                                    <td>{subscription.serviceName}</td>
                                    <td>
                                        {#if (subscription.schoolID == 0)}
                                            {subscription.matName}
                                        {:else}
                                            {subscription.estab} ({subscription.leaid}-{subscription.dfESID})
                                        {/if}
                                    </td>
                                    <!-- <td>{subscription.contactName} {#if (subscription.contactLastName != null)}{subscription.contactLastName}{/if}<br>
                                        {#if (subscription.contactEmail != null)}
                                        <small>{subscription.contactEmail} ({subscription.contactNumber})</small>
                                        {/if}
                                    </td> -->
                                    <td>{#if subscription.location == 18854}Orpington{:else if subscription.location == 91669}Doncaster{:else}&nbsp;{/if} </td>
                                    <td>{subscription.currentSubscriptionRenewalstr}</td>
                                    <td>&pound;{subscription.annualFee}</td>
                                    <td>
                                        {#if subscription.active}
                                            <span class="material-icons green" title="Active">done</span>
                                        {:else}
                                            <span class="material-icons red" title="Deactivated">clear</span>
                                        {/if}
                                    </td>
                                    <td>
                                        <a class="subscriptionActiveLink" 
                                        on:click="{() => getLinks('/app/subscriptions/' + subscription.customersID)}" 
                                        role="button" data={subscription.customersID} 
                                        href="#" data-toggle="tooltip" 
                                        target="_self" 
                                        title="Edit Subscription"><span class="material-icons">edit</span></a>
                                        <!-- <span class="material-icons" style="cursor:pointer" on:click={() => showFullDetails(subscription, false)}>edit</span> -->
                                    </td>
                                </tr>
                            {/each}   
                        </tbody>
                    </DataTable>
                </div>
            </Card>
        </div>
    </div>
{/if}
